import React, { useState } from 'react';
import axios from 'axios';
import { getUserId } from '../utils/auth';
import HeartIcon from './HeartIcon';

const FavoriteToggle = ({ articleId, initialState = false, onToggle = () => {} }) => {
  const [isFavorite, setIsFavorite] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  
  const handleToggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isLoading) return;
    
    const userId = getUserId();
    setIsLoading(true);
    
    // Mettre à jour l'état local immédiatement
    const newState = !isFavorite;
    setIsFavorite(newState);
    
    try {
      if (isFavorite) {
        // Supprimer des favoris
        await axios.delete(`http://localhost:5001/api/favorites/${articleId}`, {
          params: { userId }
        });
      } else {
        // Ajouter aux favoris
        await axios.post('http://localhost:5001/api/favorites', {
          userId,
          articleId
        });
      }
      
      // Notifier le parent du changement
      onToggle(newState);
    } catch (error) {
      console.error('Erreur lors de la modification des favoris:', error);
      // Revenir à l'état précédent en cas d'erreur
      setIsFavorite(!newState);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <button 
      className={`favorite-button ${isFavorite ? 'is-favorite' : ''}`}
      onClick={handleToggle}
      disabled={isLoading}
    >
      <HeartIcon filled={isFavorite} />
    </button>
  );
};

export default FavoriteToggle;